"use client";
import Image from "next/image";
import { Button } from "@/components/ui/button";
import Link from "next/link";
import * as images from "@/components/images/Images";
// import headerPhotoIcon from "@/components/assets/headerPhotoIcon.png";
import { Typography } from "@/components/ui/typography";
import { ROUTES } from "@/constants";

type DocumentsHeroBlockProps = {
  content: {
    heroTitle?: string;
    heroDescriptions?: string;
  };
};
export default function DocumentsHeroBlock({
  content,
}: DocumentsHeroBlockProps) {
  return (
    <section className="overflow-hidden section pt-[var(--main-header-height,56px)] lg:pt-[var(--main-header-height,54px)] bg-background-hero">
      <div className="container mx-auto">
        <div className="grid grid-cols-1 pt-6 gap-8 md:pt-30 lg:text-start lg:grid-cols-[9fr_11fr] lg:gap-[22px] lg:py-20">
          <div className="flex flex-col justify-center gap-8 lg:max-w-[540px]">
            <div className="grid grid-cols-1 gap-4 md:gap-8">
            <Typography variant="headingMain" className="w-full">
              <h1>{content.heroTitle}</h1>
            </Typography>
            <Typography variant="bodyLg" asChild>
              <p>{content.heroDescriptions}</p>
            </Typography>
            </div>
            <div className="grid grid-cols-1 gap-4 sm:flex flex-wrap lg:gap-2.5">
              <Button
                asChild
                variant="primary"
                className="sm:w-[247px] h-[48px]"
              >
                <Link href={ROUTES.startOrder} className="!text-base w-full">
                  Start order
                </Link>
              </Button>
              <Button
                asChild
                variant="primary-outline"
                className="h-[48px] sm:w-[141px]"
              >
                <Link href={ROUTES.getQuote}  className="!text-base w-full">
                  Get  a quote
                </Link>
              </Button>
            </div>
          </div>
          <div className="flex">
            <Image
              alt="Languex Illustration"
              src={images.allDocumentsHero}
              width={1249}
              height={1032}
              className=""
            />
          </div>
          {/* <div className="flex pl-6">
            <div
              className="bg-[#E6E9F1] min-h-[405px] w-[439px] rounded-3xl relative
           flex"
            >
              <div className="flex absolute top-[50px] left-[32px]">
                <Image
                  src={images.blank_cap}
                  alt="blank_cap"
                  width={0}
                  height={0}
                  priority
                  className="h-[154.56px] w-[120.28px]"
                />
              </div>
              <div className="flex absolute top-[-22px] right-[40px]">
                <Image
                  src={images.blank_bank}
                  alt="blank_bank"
                  width={0}
                  height={0}
                  priority
                  className="h-[154.56px] w-[120.28px]"
                />
              </div>
              <div className="flex absolute top-[126px] right-[150px]">
                <Image
                  src={images.blank_web}
                  alt="blank_web"
                  width={0}
                  height={0}
                  priority
                  className="h-[154.56px] w-[120.28px]"
                />
              </div>
              <div className="absolute bottom-[46px] right-[-23%]">
                <div
                  className="flex w-[156px] h-10 bg-white border-1 border-[#A5BBD9]
                         rounded-[12px] items-center gap-2 px-2 py-1 font-medium mb-2 text-[16px]"
                >
                  <Image
                    src={images.delivery_box}
                    alt="delivery_box"
                    width={0}
                    height={0}
                    priority
                    className="w-6"
                  />
                  <span className=" opacity-80 text-[17.28px] font-medium pl-1">
                    24h delivery
                  </span>
                </div>
                <div
                  className="flex  w-[190px] h-10 bg-white border-1 border-[#A5BBD9]
                         rounded-[12px] items-center gap-2 px-2 py-1 font-medium mb-2 text-[16px]"
                >
                  <Image
                    src={images.flowbite_language}
                    alt="flowbite_language"
                    width={0}
                    height={0}
                    priority
                    className="w-6 ml-1"
                  />
                  <span className=" opacity-80 text-[17.28px] font-medium">
                    100+ Languages
                  </span>
                </div>
                <div
                  className="flex w-[108px] bg-white border-1 border-[#A5BBD9]
                         rounded-[12px] items-center gap-2 px-2 py-1 font-medium text-[16px]"
                >
                  <Image
                    src={images.doc_image}
                    alt="delivery_box"
                    width={0}
                    height={0}
                    priority
                    className="w-6 ml-1"
                  />
                  <span className=" opacity-80 text-[17.28px] font-medium">
                    DOCX
                  </span>
                </div>
              </div>
              <div className="absolute bottom-[10%] left-[-8%] w-[220px]  rounded-md bg-white shadow-lg ">
                <div className="flex justify-between items-center px-3 py-2">
                  <div>
                    <Image
                      src={headerPhotoIcon}
                      alt="hero_expert_image"
                      width={0}
                      height={0}
                      priority
                      className="w-[46px] h-[auto]"
                    />
                  </div>
                  <div className="">
                    <div className="text-[17.28px] font-medium">John Rey</div>
                    <div className="flex items-center w-[136px]">
                      <Image
                        src={images.accept_star_circle}
                        alt="hero_expert_image"
                        width={0}
                        height={0}
                        priority
                        className="w-[19px] h-[19px]"
                      />
                      <div className="text-[14px] font-medium">
                        Expert Translator
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </section>
  );
}
